import { render, staticRenderFns } from "./journal-code.vue?vue&type=template&id=39d5efce&"
import script from "./journal-code.vue?vue&type=script&lang=js&"
export * from "./journal-code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports